import React from 'react'
import store from '../store'

export default [
  {
    title: '微信昵称',
    dataIndex: 'avatar_url',
    key: 'avatar_url',
    render: (avatar_url, { nick_name }) => (
      <div>
        <img
          style={{ width: 34, borderRadius: '50%', verticalAlign: '-10px' }}
          src={avatar_url + '?imageView2/1/w/34/h/34/format/webp'}
        />
        <span style={{ paddingLeft: 10 }}>{nick_name}</span>
      </div>
    )
  },
  {
    title: '真实姓名',
    dataIndex: 'real_name',
    key: 'real_name'
  },
  {
    title: '加入时间',
    dataIndex: 'created_at',
    key: 'created_at'
  },
  {
    title: '操作',
    dataIndex: 'is_admin',
    key: 'is_admin',
    render: (is_admin, { id, real_name }) => (
      <a onClick={store.del(id, real_name)}>删除</a>
    )
  }
]
